module.exports = __webpack_public_path__ + "static/media/logo_h_white.f467f534.png";